import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { fetchCities } from '@/lib/api';
import { CityType } from '@/types/address';
const useCities = stateId => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== stateId) {
    t0 = ["cities", stateId];
    t1 = () => fetchCities(stateId);
    $[0] = stateId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const t2 = !!stateId;
  let t3;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      staleTime: 3600000
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return useQuery(t3);
};
export default useCities;